import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import InvoiceModule from './InvoiceModule.vue'
import ListInvoices from './views/ListInvoices.vue'
import CreateInvoice from './views/CreateInvoice.vue'
import ShowInvoice from './views/ShowInvoice.vue'
import EditInvoice from './views/EditInvoice.vue'
import ViewInvoice from './views/ViewInvoice.vue'
import ListCustomerInvoices from './views/ListCustomerInvoices.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/invoices',
    component: InvoiceModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListInvoices',
        component: ListInvoices,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'new',
        name: 'CreateInvoice',
        component: CreateInvoice,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id',
        name: 'ShowInvoice',
        component: ShowInvoice,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'edit/:id',
        name: 'EditInvoice',
        component: EditInvoice,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  },
  {
    path: '/invoice/:id',
    name: 'ViewInvoice',
    component: ViewInvoice
  },
  {
    path: '/invoices/customer/:customerId',
    name: 'ListCustomerInvoices',
    component: ListCustomerInvoices,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE, RolesMap.CUSTOMER_ROLE] }
  }
]

export default routes
